import '@fancyapps/fancybox';
import {animateInViewport} from "../transition";
import {Timer} from "./timer";

$( '.image-carousel' ).each( function() {
	const $this = $( this );

	const swiperConfig = {
		loop: false,
		navigation: {
			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		slidesPerView: 'auto',
		spaceBetween: 8,
		grabCursor: true,
		speed: 600,
	};

	const swiper = new Swiper( this, swiperConfig );

	const slidersCount = swiper.slides.length;
	const $progressBar = $this.parents( '.carousel-container' ).find( '.progress-bar' );

	$progressBar.css( { 'width': 100 / slidersCount + '%' } );

	swiper.on( 'slideChange slideChangeTransitionEnd', function() {
		$progressBar.css( { 'left': (100 / slidersCount) * this.activeIndex + '%' } );

		const fancyboxImage = $this.find( '.swiper-slide' ).eq( swiper.realIndex ).attr( 'data-fancybox-image' );
		$this.parents( '.carousel-container' ).find( '.carousel-zoom' ).attr( 'href', fancyboxImage );
	} );
} );

$( '.card-carousel' ).each( function() {
	const $this = $( this );

	const swiperConfig = {
		loop: false,
		slidesPerView: 1,
		spaceBetween: 8,
		grabCursor: true,
		speed: 600,
		breakpoints: {
			768: {
				slidesPerView: 4,
				spaceBetween: 16,
			},
		},
	};

	const swiper = new Swiper( this, swiperConfig );
} );


$( '.tab-carousel' ).each( function() {
	const $this = $( this );
	const $container = $this.closest( '.carousel-container' );

	const swiperConfig = {
		loop: false,
		slidesPerView: 1,
		spaceBetween: 0,
		effect: 'fade',
		fadeEffect: { crossFade: true },
		speed: 500,
		allowTouchMove: false,
		autoHeight: true,
		on: {
			init: function() {
				setTimeout( () => {
					this.updateAutoHeight( 300 );
				}, 10 );
			},
			slideChangeTransitionEnd: function() {
				setTimeout( () => {
					this.updateAutoHeight( 300 );
				}, 10 );
			},
		},
	};

	const swiper = new Swiper( this, swiperConfig );

	$container.find( '.tab-carousel-navigation a' ).on( 'click', function( e ) {
		let slideIndex = $( this ).data( "slide" );

		$container.find( '.tab-carousel-navigation a' ).removeClass( 'checked' );
		$container.find( '.tab-carousel-navigation a[data-slide="' + slideIndex + '"]' ).addClass( 'checked' );

		swiper.slideTo( slideIndex );
	} );
} );

$( '.before-after-carousel' ).each( function() {
	const $this = $( this );
	const $container = $this.closest( '.carousel-container' );

	const swiperConfig = {
		loop: false,
		slidesPerView: 1,
		spaceBetween: 0,
		effect: 'fade',
		fadeEffect: { crossFade: true },
		speed: 500,
		allowTouchMove: false,
		autoHeight: true,
		on: {
			init: function() {
				setTimeout( () => {
					this.updateAutoHeight( 300 );
				}, 10 );
			},
			slideChangeTransitionEnd: function() {
				setTimeout( () => {
					this.updateAutoHeight( 300 );
				}, 10 );
			},
		},
	};

	const swiper = new Swiper( this, swiperConfig );

	$container.find( '.carousel-navigation a' ).on( 'click', function( e ) {
		let slideIndex = $( this ).data( "slide" );

		$container.find( '.carousel-navigation a' ).removeClass( 'checked' );
		$container.find( '.carousel-navigation a[data-slide="' + slideIndex + '"]' ).addClass( 'checked' );

		swiper.slideTo( slideIndex );
	} );
} );

$( '.media-carousel' ).each( function() {
	const self = this;
	const $this = $( this );

	const flkty = {
		init() {
			this.flkty = new Flickity( self, {
				prevNextButtons: false,
				pageDots: false,
				wrapAround: true,
				freeScroll: true,
				imagesLoaded: true,
			} );
			this.flkty.x = 0;
			this.autoplaySpeed = 70;
			this.loop();
		},

		loop() {
			const now = Date.now();
			const elapsedMillis = now - (this.autoplayLastTimestamp || now);
			this.autoplayLastTimestamp = now;
			this.flkty.x += (this.autoplaySpeed || 50) * elapsedMillis / 1000 * (this.autoplayDirection || -1);
			this.flkty.integratePhysics();
			this.flkty.settle( this.flkty.x );
			animateInViewport( $this );
			window.requestAnimationFrame( this.loop.bind( this ) );
		},
	};

	flkty.init();

	setTimeout( function() {
		if ( flkty.flkty ) {
			flkty.flkty.resize();
		}
	}, 500 );
} );

$( '.timeline-carousel' ).each( function() {
	const self = this;
	const $this = $( this );
	const $container = $this.closest( '.media-carousel-container' );

	const $progressBar = $container.find( '.timeline-progress' );
	const $progressButton = $container.find( '.progress-button' ); // Select play/pause button
	const $dots = $container.find( '.timeline-dot' );
	const slidersCount = $this.find( '.swiper-slide' ).length;
	const $timelineContainer = $container.find( '.timeline-container' );

	const swiperConfig = {
		// speed: 1000 * slidersCount,
		// autoplay: {
		// 	delay: 0,
		// 	disableOnInteraction: false,
		// },
		loop: false,
		autoHeight: false,
		slidesPerView: 1.428,
		allowTouchMove: false,
		grabCursor: false,
		spaceBetween: 32,
		breakpoints: {
			1024: {
				slidesPerView: 1.8181,
				spaceBetween: 64,
			},
		},
		on: {
			// reachEnd: function() {
			// 	this.autoplay.stop(); // Stop autoplay when last slide reaches the right
			// 	$progressButton.addClass( 'paused' );
			// 	$progressButton.find( '.play' ).removeClass( 'hidden' );
			// 	$progressButton.find( '.pause' ).addClass( 'hidden' );
			// },
		},
	};

	const swiper = new Swiper( this, swiperConfig );

	const timer = new Timer( {
		duration: 10000 * slidersCount,
		onProgress: function( progress ) {
			swiper.setProgress( progress );
			const offset = `${100 * progress}%`;
			const offsetProgress = $timelineContainer.width() * progress;

			$progressBar.css( { 'width': offset } );
			$progressButton.css( { 'transform': `translateX(${offsetProgress}px)` } );

			if ( progress === 1 ) {
				$progressButton.addClass( 'paused' );
				$progressButton.find( '.play' ).removeClass( 'hidden' );
				$progressButton.find( '.pause' ).addClass( 'hidden' );
			}

			const passedDots = Math.floor( timer.getProgress() * (slidersCount - 1) + 0.01 );
			$container.find( '.dot' ).each( function( index ) {
				$( this ).toggleClass( 'passed', index <= passedDots );
			} );
		},
	} );

	$( window ).on( 'resize', function() {
		const offsetProgress = $timelineContainer.width() * timer.getProgress();
		$progressButton.css( { 'transform': `translateX(${offsetProgress}px)` } );
	} );

	function startTimerIfInViewportFirstTime() {
		if ( $this.is( ':in-viewport' ) ) {
			$( window ).off( 'scroll', startTimerIfInViewportFirstTime );
			timer.start();
		}
	}

	$( window ).on( 'scroll', startTimerIfInViewportFirstTime );
	startTimerIfInViewportFirstTime();

	$container.find( '.carousel-navigation a' ).on( 'click', function( e ) {
		const slideIndex = $( this ).data( "slide" );
		timer.pause();
		timer.setProgressAnimated( slideIndex / (swiper.slides.length - 1) );

		$progressButton.addClass( 'paused' );
		$progressButton.find( '.play' ).removeClass( 'hidden' );
		$progressButton.find( '.pause' ).addClass( 'hidden' );
	} );

	$progressButton.on( 'click', function() {
		if ( $progressButton.hasClass( 'paused' ) ) {
			$( this ).removeClass( 'paused' );
			if ( timer.getProgress() === 1 ) {
				timer.setProgressAnimated( 0, () => timer.start() );
			} else {
				timer.start();
			}
		} else {
			$( this ).addClass( 'paused' );
			timer.pause();
		}

		$progressButton.find( '.play, .pause' ).toggleClass( 'hidden' );
	} );
} );

$( '.menu-carousel' ).each( function() {
	const $this = $( this );
	const $container = $this.closest( '.carousel-container' );

	const swiperConfig = {
		loop: false,
		slidesPerView: 1,
		spaceBetween: 0,
		effect: 'fade',
		fadeEffect: { crossFade: true },
		speed: 500,
		allowTouchMove: false,
		autoHeight: false,
	};

	const swiper = new Swiper( this, swiperConfig );

	// Select all menu items (li or a)
	const menuItems = document.querySelectorAll( ".site-navigation .main-menu li" );

	menuItems.forEach( ( menuItem, index ) => {
		menuItem.addEventListener( "mouseenter", function() {
			swiper.slideTo( index );
		} );
	} );
} );

$( '.key-points-carousel' ).each( function() {
	const $this = $( this );
	const $container = $this.closest( '.carousel-container' );

	const swiperConfig = {
		loop: false,
		slidesPerView: 1,
		spaceBetween: 0,
		effect: 'fade',
		fadeEffect: { crossFade: true },
		speed: 500,
		allowTouchMove: false,
		autoHeight: true,
	};

	const swiper = new Swiper( this, swiperConfig );

	$container.find( '.media-accordion-toggle' ).on( 'click', function() {
		const index = $( this ).data( 'slide' );
		swiper.slideTo( index );
	} );
} );

$( '.image-slideshow' ).each( function() {
	const $this = $( this )[ 0 ]; // Get the raw DOM element

	const swiperConfig = {
		grabCursor: false,
		slidesPerView: 1,
		spaceBetween: 0,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		loop: true,
		autoplay: {
			delay: 3000,
		},
		allowTouchMove: false,
		speed: 2000,
	};

	const swiper = new Swiper( this, swiperConfig );
} );
